{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Výber farieb",
  "twoDimensionalSlider": "2D jazdec"
}
